import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { getDrivers } from "../api/driverApi";
import "./css/DriverHistoryList.css";
import AccessControl from "../components/AccessControl";

export default function DriverHistoryList() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const { data, loading, error } = useFetch(getDrivers);

  /* Safely extract array */
  const drivers = Array.isArray(data)
    ? data
    : data?.drivers ?? data?.data ?? [];

  /* Filter by search */
  const filtered = drivers.filter((d) => {
    const term = search.toLowerCase();
    return (
      (d.name || "").toLowerCase().includes(term) ||
      (d.phone || "").toLowerCase().includes(term)
    );
  });

  const getBadgeClass = (status) => {
    const map = {
      active:  "dhl-badge dhl-badge-active",
      applied: "dhl-badge dhl-badge-applied",
      blocked: "dhl-badge dhl-badge-blocked",
    };
    return map[status] || "dhl-badge dhl-badge-default";
  };

  return (
    <div className="dhl-container">
<AccessControl
        allowedRoles={["SUPERADMIN", "ADMIN","HR", "NSM", "RSM", "ASM", "TSO"]}
        redirectTo="/404"
      />
      {/* Header */}
      <div className="dhl-header">
        <h1>Driver History</h1>
        <p>Select a driver to view their subscription &amp; payment history</p>
      </div>

      {/* Search */}
      <div className="dhl-search-bar">
        <input
          type="text"
          className="dhl-search-input"
          placeholder="Search by name or phone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Content */}
      {loading ? (
        <div>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="dhl-skeleton-row" />
          ))}
        </div>
      ) : error ? (
        <p className="dhl-error">{error}</p>
      ) : filtered.length === 0 ? (
        <div className="dhl-empty">
          <p className="dhl-empty-icon">🔍</p>
          <p className="dhl-empty-title">
            {search ? "No drivers match your search" : "No drivers found"}
          </p>
        </div>
      ) : (
        <div className="dhl-table-card">
          <table className="dhl-table">
            <thead>
              <tr>
                <th>Driver</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((d) => (
                <tr
                  key={d._id}
                  onClick={() => navigate(`/drivers/${d._id}/history`)}
                >
                  <td>
                    <p className="dhl-driver-name">{d.name || "—"}</p>
                    <p className="dhl-driver-phone">{d.phone || ""}</p>
                  </td>
                  <td>
                    <span className={getBadgeClass(d.status)}>{d.status}</span>
                  </td>
                  <td>
                    <button
                      className="dhl-view-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/drivers/${d._id}/history`);
                      }}
                    >
                      View History
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
